/* LB Update 70: "Bevor du dich verabschiedest".
   Erscheint nur am Handy, wenn der Kunde den Tab verlassen hat und zurueckkommt.
   Nie ueber Warenkorb/Newsletter und nie auf Warenkorb/Checkout.

   LB Update 89: strengere Ausloesung. iOS meldet "Seite verlassen" auch beim
   Sperren des Bildschirms, beim kurzen Blick in eine andere App und beim
   Kontrollzentrum. Der einzige Hebel ist die Dauer.

   LB Update 127 (Sascha, 20.09.): Das Fenster soll JEDES MAL kommen, wenn er
   den Browser schliesst und nach 10 Sekunden wieder oeffnet. Deshalb:
   - MIN_WEG zurueck auf 10 s (war 30 s),
   - Mindestaufenthalt zurueck auf 8 s,
   - die Sperre "einmal pro Sitzung" entfaellt,
   - MAX_RUHE auf 150 s: laenger als die uebliche Lesepause, kuerzer als eine
     Abwesenheit. Der Bildschirm, der von selbst zugeht, kommt nach einer
     Ruhephase und wird weiterhin nicht als Verlassen gewertet. Das ist der
     einzige verbliebene Schutz gegen ein Fenster, das aufgeht, obwohl niemand
     die Seite verlassen hat.

   LB Update 127, zweiter Teil: die vier Karten kommen jetzt aus dem Vorrat in
   <template id="LBWkPool">. Vier Plaetze - Sale, Bundle, NEW IN, Zufall -,
   bei jedem Anzeigen neu gezogen und neu angeordnet. Artikel, die bereits im
   Warenkorb liegen, fallen raus. */
(function () {
  'use strict';
  var box, weg = 0, handy, sperrPos = 0, gesperrt = false, weiterGeklickt = false, vorFokus = null;
  var start = Date.now(), letzteTat = Date.now();
  var MIN_AUF_SEITE = 8000, MIN_WEG = 10000, MAX_WEG = 1800000, MAX_RUHE = 150000;

  /* ---------- Karten auswaehlen ---------- */
  var korbIds = [], korbZeit = 0;

  function korbHolen(fertig) {
    /* Hoechstens alle 20 s neu fragen; faellt die Anfrage aus, nehmen wir den
       letzten bekannten Stand - lieber ein Vorschlag zu viel als kein Fenster. */
    if (Date.now() - korbZeit < 20000) { fertig(); return; }
    var erledigt = false;
    function weiter() { if (!erledigt) { erledigt = true; fertig(); } }
    setTimeout(weiter, 600);
    try {
      fetch('/cart.js', { credentials: 'same-origin' })
        .then(function (r) { return r.ok ? r.json() : null; })
        .then(function (d) {
          if (d && d.items) {
            korbIds = d.items.map(function (i) { return String(i.product_id); });
            korbZeit = Date.now();
          }
          weiter();
        })
        .catch(weiter);
    } catch (e) { weiter(); }
  }

  function mischen(liste) {
    for (var i = liste.length - 1; i > 0; i--) {
      var j = Math.floor(Math.random() * (i + 1));
      var t = liste[i]; liste[i] = liste[j]; liste[j] = t;
    }
    return liste;
  }

  function fuellen() {
    var vorrat = document.getElementById('LBWkPool');
    var gitter = box && box.querySelector('.lb-wk__gitter');
    if (!vorrat || !vorrat.content || !gitter) return;

    var alle = [].slice.call(vorrat.content.querySelectorAll('.lb-wk__karte'));
    var frei = alle.filter(function (k) {
      /* Eine Bundle-Karte traegt alle Produkt-IDs ihres Sets: liegt eines der
         Teile schon im Warenkorb, faellt das ganze Set weg. */
      var ids = (k.getAttribute('data-pids') || k.getAttribute('data-pid') || '').split(',');
      for (var i = 0; i < ids.length; i++) {
        if (ids[i] && korbIds.indexOf(ids[i]) > -1) return false;
      }
      return true;
    });
    if (frei.length < 4) frei = alle;   /* Warenkorb fast leergeraeumt: lieber zeigen */

    var genommen = [], staemme = [], gruppen = [];

    /* "Leoprint Jersey Stoffhose" und "Leoprint Jersey Stoffhose Tall - 3er-Set"
       sind zwei verschiedene Staemme, zeigen aber dasselbe Modell. Deshalb gilt
       auch als doppelt, wenn ein Stamm mit dem anderen anfaengt. */
    function stammBelegt(st) {
      if (!st) return false;
      for (var i = 0; i < staemme.length; i++) {
        var a = staemme[i];
        if (a === st) return true;
        if (a.length >= 8 && st.length >= 8 && (a.indexOf(st) === 0 || st.indexOf(a) === 0)) return true;
      }
      return false;
    }

    function ziehen(gruppe, gruppeMeiden) {
      var kand = frei.filter(function (k) {
        if (genommen.indexOf(k) > -1) return false;
        if (stammBelegt(k.getAttribute('data-stamm'))) return false;
        var gr = k.getAttribute('data-gruppe');
        if (gruppe) return gr === gruppe;
        if (gruppeMeiden && gruppen.indexOf(gr) > -1) return false;
        return true;
      });
      if (!kand.length) return null;
      var w = kand[Math.floor(Math.random() * kand.length)];
      genommen.push(w);
      var s = w.getAttribute('data-stamm'); if (s) staemme.push(s);
      var g = w.getAttribute('data-gruppe'); if (g) gruppen.push(g);
      return w;
    }

    /* Drei feste Plaetze, dann der Zufallsplatz. Der zieht aus einer noch nicht
       benutzten Gruppe - also aus den Bestsellern oder aus dem Zufallstopf, der
       quer durch die Kategorien reicht. So steht nie zweimal dasselbe Etikett
       im Fenster. Geht das nicht (z. B. alles schon im Warenkorb), darf er aus
       allem Uebrigen ziehen. */
    var wahl = [ziehen('sale'), ziehen('bundle'), ziehen('new')];
    var zufall = ziehen(null, true) || ziehen(null, false);
    if (zufall) wahl.push(zufall);
    wahl = wahl.filter(Boolean);
    if (!wahl.length) return;

    mischen(wahl);
    gitter.innerHTML = '';
    wahl.forEach(function (k) { gitter.appendChild(k.cloneNode(true)); });
  }

  /* ---------- Fenster ---------- */
  /* LB Update 281 (Sascha 30.09., Video 20:51): Beim Schliessen von "Bevor du dich verabschiedest" sprang oben die Leiste/der Kopf.
     Ursache (vermutet, nur am iPhone pruefbar): Die Seite wurde mit position:fixed festgesetzt und beim Schliessen mit scrollTo
     zurueckgesetzt - das wertet Safari als Scrollen und faehrt die Leisten um. Jetzt wird die Seite nur mit overflow:hidden
     gesperrt (kein Verschieben, kein scrollTo). Das Wegwischen des Hintergrunds verhindert weiter der touchmove-Schutz unten. */
  function sperren() {
    if (gesperrt) return;
    sperrPos = window.pageYOffset || document.documentElement.scrollTop || 0;
    document.documentElement.style.overflow = 'hidden';
    document.body.style.overflow = 'hidden';
    gesperrt = true;
  }
  function freigeben() {
    if (!gesperrt) return;
    document.documentElement.style.overflow = '';
    document.body.style.overflow = '';
    gesperrt = false;
    if ((window.pageYOffset || 0) !== sperrPos) window.scrollTo(0, sperrPos);
  }
  function darf() {
    if (!handy.matches) return false;
    if (Date.now() - start < MIN_AUF_SEITE) return false;
    if (/\/(cart|checkouts?|challenge)(\/|$)/.test(location.pathname)) return false;
    if (document.documentElement.classList.contains('lb-cart-scroll-locked')) return false;
    if (document.querySelector('.modal--is-active, #CartDrawer.is-open, .drawer--is-open')) return false;
    if (document.documentElement.classList.contains('lb-bis-open')) return false; /* LB Update 256 */
    return true;
  }
  function zeigen() {
    if (!box || !box.hidden || !darf()) return;
    korbHolen(function () {
      if (!box.hidden || !darf()) return;
      try { fuellen(); } catch (e) {}
      if (!box.querySelector('.lb-wk__karte')) return;   /* nichts zu zeigen */
      vorFokus = document.activeElement;
      box.hidden = false;
      box.setAttribute('aria-hidden', 'false');
      sperren();
      var b = box.querySelector('.lb-wk__btn');
      if (b) b.focus({ preventScroll: true });
    });
  }
  function schliessen() {
    if (!box || box.hidden) return;
    box.hidden = true;
    box.setAttribute('aria-hidden', 'true');
    freigeben();
    if (vorFokus && vorFokus !== document.body && vorFokus.focus && document.contains(vorFokus)) {
      try { vorFokus.focus({ preventScroll: true }); } catch (e) {}
    }
    vorFokus = null;
  }
  function init() {
    box = document.getElementById('LBWieder');
    if (!box || box.dataset.lbBereit) return;
    box.dataset.lbBereit = '1';
    handy = window.matchMedia('(max-width:768px)');
    var korb = document.getElementById('CartDrawer'), korbFokus = null, korbTimer = 0, korbDarueber = false;
    var stapelStil = document.createElement('style');
    stapelStil.textContent = 'html.lb-cart-over-wk #CartDrawer{z-index:62!important}html.lb-cart-over-wk #CartDrawer + .drawer__overlay{z-index:61!important}';
    document.head.appendChild(stapelStil);
    document.addEventListener('cart:open', function () {
      if (!box.hidden && !korbDarueber) korbFokus = document.activeElement;
    }, true);
    function korbStapel() {
      var offen = korb && korb.classList.contains('drawer--is-open') && !box.hidden;
      if (offen) {
        clearTimeout(korbTimer);korbDarueber = true;
        document.documentElement.classList.add('lb-cart-over-wk');
        box.inert = true;box.setAttribute('aria-hidden','true');
      } else if (korbDarueber) {
        korbDarueber = false;
        document.documentElement.classList.remove('lb-cart-over-wk');
        box.inert = false;box.setAttribute('aria-hidden',box.hidden?'true':'false');
        korbTimer = setTimeout(function () {
          if (box.hidden || (korb && korb.classList.contains('drawer--is-open'))) return;
          var ziel = korbFokus && box.contains(korbFokus) ? korbFokus : box.querySelector('.lb-wk__btn');
          if (ziel && ziel.focus) ziel.focus({preventScroll:true});
          korbFokus = null;
        },550);
      }
    }
    if (korb) new MutationObserver(korbStapel).observe(korb,{attributes:true,attributeFilter:['class']});
    new MutationObserver(function () {
      if (!box.hidden && document.documentElement.classList.contains('lb-sheet-offen')) schliessen();
    }).observe(document.documentElement, {attributes:true, attributeFilter:['class']});
    box.addEventListener('click', function (e) {
      if (e.target === box || e.target.closest('[data-lb-wk-zu]')) { e.preventDefault(); schliessen(); }
    });
    box.addEventListener('touchmove', function (e) {
      if (!e.target.closest('.lb-wk__box')) e.preventDefault();
    }, { passive: false });
    document.addEventListener('keydown', function (e) {
      if (box && box.inert) return;
      if (e.key === 'Escape') { schliessen(); return; }
      /* Tab/Shift+Tab bleiben im offenen Fenster */
      if (e.key !== 'Tab' || !box || box.hidden) return;
      var f = [].filter.call(box.querySelectorAll('a[href],button:not([disabled]),select:not([disabled]),input:not([disabled]),[tabindex]:not([tabindex="-1"])'), function (x) { return x.offsetParent !== null; });
      if (!f.length) return;
      var i = f.indexOf(document.activeElement);
      if (e.shiftKey && i <= 0) { e.preventDefault(); f[f.length - 1].focus(); }
      else if (!e.shiftKey && (i === -1 || i === f.length - 1)) { e.preventDefault(); f[0].focus(); }
    });
    /* LB Update 156 (Sascha, 21.09.): Das Fenster ging bei JEDEM Zurueck auf.
       Zwei Ursachen:
       1. pageshow aus dem Zurueck-Speicher des Browsers loeste zeigen() aus -
          ohne jede Zeitpruefung. Diese Ausloesung entfaellt.
       2. Der Wechsel auf eine andere Shop-Seite versteckt die aktuelle Seite
          und zaehlte damit als "Seite verlassen". Wer dort laenger als 10 s
          blieb und zurueck tippte, bekam das Fenster.
       Jetzt gilt: Wer innerhalb des Shops weiterklickt (pagehide), hat die
       Seite nicht verlassen. Beim Zurueckholen aus dem Speicher wird alles auf
       Anfang gesetzt, wie bei einem frischen Seitenaufruf. Das eigentliche
       Verhalten bleibt: Browser/App verlassen, nach 10 s zurueck -> Fenster. */
    window.addEventListener('pagehide', function () {
      weiterGeklickt = true;
      weg = 0;
      freigeben();
    });
    ['touchstart', 'pointerdown', 'click', 'scroll', 'keydown'].forEach(function (n) {
      document.addEventListener(n, function () { letzteTat = Date.now(); }, { passive: true, capture: true });
    });
    document.addEventListener('visibilitychange', function () {
      if (document.visibilityState === 'hidden') {
        /* War der Kunde vorher laenger untaetig, ist der Bildschirm vermutlich
           von selbst zugegangen - das ist kein Verlassen der Seite.
           Ein Klick auf eine andere Shop-Seite ist es auch nicht. */
        weg = (!weiterGeklickt && Date.now() - letzteTat <= MAX_RUHE) ? Date.now() : 0;
        return;
      }
      if (weiterGeklickt) { weg = 0; letzteTat = Date.now(); return; }
      var her = weg ? Date.now() - weg : 0;
      weg = 0;
      letzteTat = Date.now();
      if (her >= MIN_WEG && her <= MAX_WEG) setTimeout(zeigen, 220);
    });
    window.addEventListener('pageshow', function (e) {
      if (!e.persisted) return;
      /* Zurueck aus dem Speicher: wie ein frischer Aufruf behandeln, kein Fenster. */
      weiterGeklickt = false;
      weg = 0;
      start = Date.now();
      letzteTat = Date.now();
      schliessen();
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, { once: true });
  else init();
})();

/* LB Update 158 (Sascha, 21.09.): Doppeltippen am Handy.
   lb-optimizer.js laedt die zurueckgestellten Skripte (Judge.me, Apps, das
   Konto-Symbol ...) genau in dem Moment, in dem der Finger das Glas beruehrt.
   Aendert sich dabei sichtbar etwas, wertet das iPhone die Beruehrung als
   "Maus darueber" und verwirft den Klick - man muss ein zweites Mal tippen.
   Hier wird das Nachladen fuer touchstart/mousedown/mousemove/click um
   700 ms nach hinten geschoben: erst kommt der Klick an, dann wird
   nachgeladen. mousemove gehoert dazu, weil auch das iPhone bei jedem Tippen
   eine Mausbewegung meldet. Scrollen und Tastatur loesen weiterhin sofort aus.
   Das steht hier und nicht in lb-optimizer.js, weil diese Datei vor
   lb-optimizer.js geladen wird und sich deshalb an DOMContentLoaded haengen
   kann - dann sind beide Skripte durchgelaufen. lb-optimizer.js selbst bleibt
   unveraendert. */
(function () {
  'use strict';
  var erledigt = false;
  function umhaengen() {
    if (erledigt) return;
    var laden = window.loadJSscripts;
    if (typeof laden !== 'function') return;
    erledigt = true;
    var geplant = false;
    function spaeter() {
      if (geplant) return;
      geplant = true;
      setTimeout(laden, 700);
    }
    ['touchstart', 'mousedown', 'mousemove', 'click'].forEach(function (typ) {
      window.removeEventListener(typ, laden, false);
      window.addEventListener(typ, spaeter, { passive: true });
    });
  }
  /* Aufgeschobene Skripte laufen, wenn der Ladezustand schon "interactive" ist -
     lb-optimizer.js ist dann aber noch nicht dran. Deshalb immer auf
     DOMContentLoaded warten (feuert erst, wenn alle aufgeschobenen Skripte
     durch sind) und zur Sicherheit auf load. */
  if (document.readyState === 'complete') umhaengen();
  else {
    document.addEventListener('DOMContentLoaded', umhaengen, { once: true });
    window.addEventListener('load', umhaengen, { once: true });
  }
})();

/* Warenkorb erst öffnen, wenn er neu aufgebaut ist (kein kurzes „Deine Tasche ist leer“ nach Schnellkauf) */
(function () {
  'use strict';
  var letzterBau = 0, sofortBereit = false;
  window.addEventListener('cart:build', function (e) {
    letzterBau = Date.now();
    var html = e.detail && e.detail.markup;
    sofortBereit = typeof html === 'string' && html.indexOf('class="cart__items"') !== -1;
  }, true);
  window.addEventListener('cart:open', function (e) {
    if (e.detail && e.detail.lbDurch) return;
    if (Date.now() - letzterBau > 150 || sofortBereit) return;
    var ziel = document.querySelector('#CartDrawer [data-products]');
    if (!ziel || typeof MutationObserver !== 'function') return;
    e.stopImmediatePropagation();
    var fertig = false, beob, uhr;
    function oeffnen() {
      if (fertig) return; fertig = true;
      if (beob) beob.disconnect(); clearTimeout(uhr);
      document.dispatchEvent(new CustomEvent('cart:open', { detail: { lbDurch: true } }));
    }
    beob = new MutationObserver(function () { setTimeout(oeffnen, 30); });
    beob.observe(ziel, { childList: true });
    uhr = setTimeout(oeffnen, 1500);
  }, true);
})();

/* Newsletter-Popup nicht automatisch öffnen, solange Warenkorb/Menü/Filter offen sind – sonst schließt es diese */
(function () {
  'use strict';
  function einhaengen() {
    var M = window.theme && window.theme.Modals;
    if (!M || !M.prototype || M.prototype.__lbWarte) return;
    var orig = M.prototype.open;
    /* LB Update 256: auch warten, solange das Benachrichtigen-Fenster (Back in Stock) offen ist -
       sonst legt sich das Newsletter-Popup darueber und blockiert beide Fenster. */
    function belegt() {
      var h = document.documentElement.classList;
      return !!document.querySelector('.drawer--is-open,.site-header__search-container.is-active') || h.contains('lb-bis-open');
    }
    M.prototype.open = function (evt) {
      var self = this;
      if (!evt && self.id && self.id.indexOf('NewsletterPopup') === 0 && belegt()) {
        var uhr = setInterval(function () {
          if (belegt()) return;
          clearInterval(uhr);
          setTimeout(function () {
            if (!belegt()) orig.call(self);
            else M.prototype.open.call(self);
          }, 250);
        }, 500);
        return;
      }
      return orig.apply(this, arguments);
    };
    M.prototype.__lbWarte = true;
  }
  if (document.readyState === 'complete') einhaengen();
  else { document.addEventListener('DOMContentLoaded', einhaengen, { once: true });
         window.addEventListener('load', einhaengen, { once: true }); }
})();

/* LB Update 251 (J4): Newsletter-Popup erst zeigen, wenn die Besucherin die Seite mindestens einmal
   beruehrt hat (Maus bewegt, getippt, geklickt, Taste, Mausrad, Seite gescrollt).
   Der 20-s-Zeitgeber von Impulse (theme.js, ab Seitenaufruf) bleibt unveraendert, ebenso Cookies,
   sessionStorage "newsletterAppeared", Erinnerungs-Blase, Sperre und Warte-Logik bei offenem Warenkorb.
   Nur wenn der Zeitgeber ablaeuft, OHNE dass bis dahin irgendeine Beruehrung kam, wartet das Popup
   auf die erste Beruehrung und oeffnet genau dann (wie heute: das Fenster ist da, bevor der erste
   Tipp ankommt; die LB-170-Sperre faengt diesen Tipp ab wie bisher). Die Sitzungsmarke
   "newsletterAppeared" wird erst gesetzt, wenn das Fenster wirklich aufging.
   Grund: Google-/Lighthouse-Tests beruehren die Seite nie; dort wurde das Popup-Bild nach 20 s
   zum groessten Element (LCP 7-8 s). Beruehrungen vor dem Laden dieser Datei merkt sich
   social-meta-tags.liquid (window.__lbTat). Fehler-/Erfolgsmeldung nach dem Absenden, Aufruf ueber
   die Blase und der Theme-Editor sind ausgenommen. */
(function () {
  'use strict';
  var tat = !!window.__lbTat, wartend = null;
  var arten = ['mousemove', 'pointerdown', 'touchstart', 'keydown', 'wheel', 'scroll'];
  function merken(e) {
    if (tat) return;
    /* Nur Scrollen der ganzen Seite zaehlt (Leisten richten sich beim Laden selbst aus). */
    if (e && e.type === 'scroll' && e.target !== document && e.target !== window && e.target !== document.documentElement) return;
    tat = true;
    for (var i = 0; i < arten.length; i++) window.removeEventListener(arten[i], merken, true);
    if (bald) bildVorladen();   /* LB Update 253 (N3) */
    if (wartend) {
      var m = wartend; wartend = null;
      m.open();
      try { sessionStorage.setItem('newsletterAppeared', true); } catch (x) {}
    }
  }
  if (!tat) for (var i = 0; i < arten.length; i++) window.addEventListener(arten[i], merken, { capture: true, passive: true });
  function beruehrt() {
    if (!tat && (window.__lbTat || (window.pageYOffset || 0) > 0)) tat = true;
    return tat;
  }
  /* LB Update 253 (N3): Popup-Foto (nur Desktop sichtbar, loading="lazy") kurz VOR dem Oeffnen laden, damit es
     mit dem Blatt erscheint statt ~0,4 s spaeter. Frueh genug, aber ohne den Seitenstart zu belasten:
     erst 2,5 s vor Ablauf des Impulse-Zeitgebers und nur, wenn die Seite schon beruehrt wurde (sonst bei der
     ersten Beruehrung - dann geht das Popup ohnehin auf). Nicht, wenn das Popup gar nicht mehr kommt
     (Cookie / schon erschienen), nicht am Handy (Foto dort ausgeblendet), nicht im Theme-Editor. */
  var bald = false, vorGeladen = false;
  function bildVorladen() {
    if (vorGeladen) return;
    vorGeladen = true;
    try {
      var el = document.querySelector('[id^="NewsletterPopup-"]');
      var img = el && el.querySelector('.newsletter-popup__image');
      if (!img || img.loading !== 'lazy' || img.complete) return;
      if (!window.matchMedia('(min-width:769px)').matches) return;
      img.loading = 'eager';
      if (img.decode) img.decode().catch(function () {});
    } catch (x) {}
  }
  function vorladenPlanen() {
    try {
      var el = document.querySelector('[id^="NewsletterPopup-"][data-delay-seconds]');
      if (!el || (window.Shopify && window.Shopify.designMode) || el.getAttribute('data-test-mode') === 'true') return;
      var sek = parseFloat(el.getAttribute('data-delay-seconds'));
      if (!(sek > 0)) return;
      if (document.cookie.indexOf('newsletter-' + el.getAttribute('data-section-id') + '=') > -1) return;
      if (sessionStorage.getItem('newsletterAppeared') === 'true') return;
      setTimeout(function () { bald = true; if (beruehrt()) bildVorladen(); }, Math.max(0, sek * 1000 - 2500));
    } catch (x) {}
  }
  function einhaengen() {
    if (!einhaengen.__lbVor) { einhaengen.__lbVor = true; vorladenPlanen(); }   /* LB Update 253 (N3) */
    var M = window.theme && window.theme.Modals;
    if (!M || !M.prototype || M.prototype.__lbErstTat) return;
    var vorher = M.prototype.open;
    M.prototype.open = function (evt) {
      if (!evt && this.id && this.id.indexOf('NewsletterPopup') === 0 && !beruehrt() &&
          !(window.Shopify && window.Shopify.designMode)) {
        var el = document.getElementById(this.id);
        if (!(el && el.querySelector('.errors, .note--success'))) {
          wartend = this;
          /* theme.js setzt die Marke direkt nach open() - solange nichts zu sehen war, wieder entfernen */
          var alt = null;
          try { alt = sessionStorage.getItem('newsletterAppeared'); } catch (x) {}
          setTimeout(function () {
            if (!wartend || alt === 'true') return;
            try { sessionStorage.removeItem('newsletterAppeared'); } catch (x) {}
          }, 0);
          return;
        }
      }
      return vorher.apply(this, arguments);
    };
    M.prototype.__lbErstTat = true;
  }
  if (document.readyState === 'complete') einhaengen();
  else { document.addEventListener('DOMContentLoaded', einhaengen, { once: true });
         window.addEventListener('load', einhaengen, { once: true }); }
})();

/* LB Update 253 (N3): Newsletter-Popup - Bewegung erst im zweiten Bild nach dem Oeffnen/Schliessen starten.
   Das erste Bild nach dem Oeffnen ist teuer (Klasse modal-open auf <html> -> ganze Seite neu berechnen,
   WebKit/Handy >150 ms); lief die Animation da schon, war sie beim ersten sichtbaren Bild fast vorbei (Sprung).
   Solange .lb-nl-warte gesetzt ist, steht die Animation (css-zusatz LB 253 N3) auf ihrem Anfang:
   Blatt deckend, am Handy unter dem Bildschirmrand, Schleier 0. Rueckfall: nach 500 ms laeuft sie in jedem Fall. */
(function () {
  'use strict';
  function init() {
    var m = document.querySelector('[id^="NewsletterPopup-"]');
    if (!m || m.__lbNlAn) return;
    m.__lbNlAn = true;
    var n = 0, anUhr = 0;
    function an(ende) {   /* .lb-nl-an nur waehrend der Bewegung (Blattfarbe unter dem Blatt, siehe css-zusatz) */
      clearTimeout(anUhr);
      if (ende) { m.classList.remove('lb-nl-an'); return; }
      m.classList.add('lb-nl-an');
      anUhr = setTimeout(function () { m.classList.remove('lb-nl-an'); }, 1200);
    }
    function warten(e) {
      var meins = ++n, fertig = false;
      m.classList.add('lb-nl-warte');
      an(false);
      function los() { if (fertig) return; fertig = true; if (meins === n) m.classList.remove('lb-nl-warte'); }
      requestAnimationFrame(function () { requestAnimationFrame(los); });
      setTimeout(los, 500);
    }
    m.addEventListener('animationend', function (e) {
      if (e.animationName && e.animationName.indexOf('lb-nl-') === 0) an(true);
    });
    document.addEventListener('modalOpen.' + m.id, warten);
    document.addEventListener('modalClose.' + m.id, warten);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, { once: true });
  else init();
})();

/* LB 165: "Weiterlesen" fuer lange Bewertungen in allen Bewertungs-Karussells.
   Gekuerzte Karten bekommen einen kleinen Link; er oeffnet die ganze Bewertung
   in einem Fenster. Karten, Slider und Judge.me bleiben unveraendert. */
(function(){
  if(window.lbMehrBereit)return;window.lbMehrBereit=true;
  var TXT=(document.documentElement.lang||'de').slice(0,2);
  var L={de:['Weiterlesen','Schließen'],en:['Read more','Close'],nl:['Lees meer','Sluiten'],fr:['Lire la suite','Fermer'],pl:['Czytaj dalej','Zamknij'],it:['Leggi tutto','Chiudi'],es:['Leer más','Cerrar']}[TXT]||['Weiterlesen','Schließen'];
  function kuerzen(b,z){
    var lh=parseFloat(getComputedStyle(b).lineHeight)||20;
    b.style.setProperty('-webkit-line-clamp',String(z),'important');
    b.style.setProperty('max-height',Math.ceil(z*lh)+'px','important');
  }
  /* Link darf Farbangabe und "Verifizierter Kauf" nicht beruehren: notfalls Zeilen weniger */
  function frei(k){
    var m=k.querySelector('.lb-mehr'),b=k.querySelector('.jdgm-carousel-item__review-body');if(!m||!b||!m.offsetWidth)return;
    var hin=[k.querySelector('.lb-mb-farbe'),k.querySelector('.jdgm-rev__buyer-badge')].filter(Boolean);
    function stoesst(){var r=m.getBoundingClientRect();return hin.some(function(h){var q=h.getBoundingClientRect();return q.width&&!(r.right<=q.left||q.right<=r.left||r.bottom<=q.top-3||q.bottom<=r.top);});}
    var z=parseInt(getComputedStyle(b).webkitLineClamp,10)||0;
    while(z>1&&stoesst()){z--;kuerzen(b,z);}
  }
  function pruefen(){
    document.querySelectorAll('.jdgm-carousel-wrapper .jdgm-carousel-item[data-lb-mehr]').forEach(frei);
    document.querySelectorAll('.jdgm-carousel-wrapper .jdgm-carousel-item').forEach(function(k){
      if(k.hasAttribute('data-lb-mehr'))return;
      var b=k.querySelector('.jdgm-carousel-item__review-body');if(!b||!b.clientHeight)return;
      k.setAttribute('data-lb-mehr','');
      if(b.scrollHeight<=b.clientHeight+2)return;
      var n=parseInt(getComputedStyle(b).webkitLineClamp,10);
      if(n>2)kuerzen(b,n-1);
      var m=document.createElement('button');m.type='button';m.className='lb-mehr';m.textContent=L[0];
      if(k.hasAttribute('data-lb-clone'))m.tabIndex=-1;
      b.insertAdjacentElement('afterend',m);frei(k);
    });
  }
  var pop=null,zuletzt=null;
  function zu(){if(!pop)return;pop.remove();pop=null;document.documentElement.classList.remove('lb-mehr-offen');if(zuletzt&&zuletzt.focus)zuletzt.focus();}
  function auf(k,knopf){
    zu();zuletzt=knopf;
    var q=function(s){var e=k.querySelector(s);return e?e.textContent.trim():'';};
    pop=document.createElement('div');pop.className='lb-mehr-pop';pop.setAttribute('role','dialog');pop.setAttribute('aria-modal','true');
    var box=document.createElement('div');box.className='lb-mehr-pop__box';pop.appendChild(box);
    var x=document.createElement('button');x.type='button';x.className='lb-mehr-pop__zu';x.setAttribute('aria-label',L[1]);x.innerHTML='&times;';box.appendChild(x);
    var st=k.querySelector('.jdgm-carousel-item__review-rating');if(st){var s2=st.cloneNode(true);s2.style.display='';s2.className+=' lb-mehr-pop__sterne';box.appendChild(s2);}
    var t=document.createElement('p');t.className='lb-mehr-pop__titel';t.textContent=q('.jdgm-carousel-item__review-title');if(t.textContent)box.appendChild(t);
    var tx=document.createElement('div');tx.className='lb-mehr-pop__text';tx.textContent=q('.jdgm-carousel-item__review-body');box.appendChild(tx);
    var fu=document.createElement('p');fu.className='lb-mehr-pop__name';
    var fa=q('.lb-mb-farbe');fu.textContent=q('.jdgm-carousel-item__reviewer-name')+(fa?' · '+fa:'')+(k.querySelector('.jdgm-rev__buyer-badge')?' · ✓ '+({de:'Verifizierter Kauf',en:'Verified purchase',nl:'Geverifieerde aankoop',fr:'Achat vérifié',pl:'Zweryfikowany zakup',it:'Acquisto verificato',es:'Compra verificada'}[TXT]||'Verifizierter Kauf'):'');box.appendChild(fu);
    pop.setAttribute('aria-label',t.textContent||L[0]);
    document.body.appendChild(pop);document.documentElement.classList.add('lb-mehr-offen');x.focus();
  }
  document.addEventListener('click',function(e){
    var m=e.target.closest&&e.target.closest('.lb-mehr');
    if(m){e.preventDefault();e.stopPropagation();var k=m.closest('.jdgm-carousel-item');if(k)auf(k,m);return;}
    if(pop&&(e.target===pop||e.target.closest('.lb-mehr-pop__zu'))){e.preventDefault();zu();}
  },true);
  document.addEventListener('keydown',function(e){if(pop&&e.key==='Escape')zu();else if(pop&&e.key==='Tab'){e.preventDefault();var x=pop.querySelector('.lb-mehr-pop__zu');if(x)x.focus();}});
  var t=0;function bald(){if(t)return;t=setTimeout(function(){t=0;pruefen();},250);}
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',pruefen,{once:true});else pruefen();
  new MutationObserver(bald).observe(document.documentElement,{childList:true,subtree:true});
  if(document.fonts&&document.fonts.ready)document.fonts.ready.then(bald);
  window.addEventListener('load',function(){setTimeout(pruefen,800);});
  window.addEventListener('resize',function(){document.querySelectorAll('[data-lb-mehr]').forEach(function(k){if(!k.querySelector('.lb-mehr'))k.removeAttribute('data-lb-mehr');});bald();});
})();

/* LB 170: Solange das Newsletter-Fenster offen ist, loest ein Tippen/Klicken auf die Seite dahinter nichts aus
   (kein Produkt, kein Filter, kein Menue). Geschlossen wird es nur ueber das Kreuz (am Computer auch mit Esc).
   Ausgenommen sind das Fenster selbst und das Cookie-Fenster von Cookiebot. */
/* LB Update 272 (Sascha 30.09.): Am Handy schliesst ein Tipp ins Leere (neben das Fenster) das Newsletter-Fenster -
   wie beim Benachrichtigen-Fenster. Ist gerade die Tastatur offen (E-Mail-Feld aktiv), geht beim ersten Tipp nur die
   Tastatur zu. Der Tipp loest weiterhin nichts auf der Seite dahinter aus. Am Computer bleibt es beim Kreuz und Esc.
   Ausserdem: gleicher dunkler Schleier wie beim Benachrichtigen-Fenster (sichtbar rgba(36,33,30,.55)), Handy und Computer. */
(function(){
  if(window.lbNlSperre)return;window.lbNlSperre=true;
  try{var st=document.createElement('style');st.id='lb-nl-schleier';
    /* Theme blendet den Schleier auf 60 % ein (overlay-on) -> Farbe .92 ergibt sichtbar .55 wie beim Benachrichtigen-Fenster.
       Am Handy hatte das Theme den Schleier bei "mobile-friendly"-Fenstern ganz ausgeblendet (display:none). */
    st.textContent='html.modal-open [id^="NewsletterPopup-"].modal::before,html.modal-closing [id^="NewsletterPopup-"].modal::before{background-color:rgba(36,33,30,.92)}'+
      '@media (max-width:768px){html.modal-open [id^="NewsletterPopup-"].modal.modal--mobile-friendly::before,html.modal-closing [id^="NewsletterPopup-"].modal.modal--mobile-friendly::before{display:block}}';
    (document.head||document.documentElement).appendChild(st);}catch(x){}
  var handy=window.matchMedia?window.matchMedia('(max-width:768px)'):null,tipp=null,aussen=false;
  function offen(){return document.querySelector('[id^="NewsletterPopup-"].modal--is-active');}
  function daneben(m){
    var a=document.activeElement;
    if(a&&m.contains(a)&&/^(INPUT|TEXTAREA|SELECT)$/.test(a.tagName)){try{a.blur();}catch(x){}return;}
    var x=m.querySelector('.js-modal-close');if(x)x.click();
  }
  function sperre(e){
    var m=offen();if(!m){tipp=null;return;}
    var t=e.target;if(!t||!t.closest)return;
    if(t.closest('.modal__inner')&&m.contains(t)){if(e.type==='mousedown'||e.type==='pointerdown')aussen=false;return;}
    if(t.closest('#CybotCookiebotDialog,[id^="CybotCookiebot"],.klaviyo-form,[class*="kl-private"]'))return;
    if(handy&&handy.matches){
      if(e.type==='touchstart'&&e.touches&&e.touches.length===1){tipp={x:e.touches[0].clientX,y:e.touches[0].clientY};}
      else if(e.type==='touchstart'){tipp=null;}
      else if(e.type==='touchend'&&tipp&&e.changedTouches&&e.changedTouches[0]){
        var c=e.changedTouches[0],ok=Math.abs(c.clientX-tipp.x)<12&&Math.abs(c.clientY-tipp.y)<12;tipp=null;
        if(ok)setTimeout(function(){var mm=offen();if(mm)daneben(mm);},0);
      }
    }
    else{
      /* LB Update 288 (Sascha 01.10., Safari am Mac): Am Computer schliesst ein Klick auf den abgedunkelten Bereich neben dem Fenster
         das Newsletter-Fenster (wie das Kreuz). Nur wenn Maustaste UND Loslassen ausserhalb waren (kein versehentliches Schliessen
         beim Markieren von Text). Der Klick loest weiterhin nichts auf der Seite dahinter aus. */
      if(e.type==='mousedown'||e.type==='pointerdown')aussen=true;
      else if(e.type==='click'&&aussen){aussen=false;setTimeout(function(){var mm=offen(),x=mm&&mm.querySelector('.js-modal-close');if(x)x.click();},0);}
    }
    if(e.cancelable)e.preventDefault();
    e.stopPropagation();if(e.stopImmediatePropagation)e.stopImmediatePropagation();
  }
  ['touchstart','touchend','pointerdown','pointerup','mousedown','mouseup','click','dblclick','contextmenu'].forEach(function(t){
    window.addEventListener(t,sperre,{capture:true,passive:false});
  });
})();

/* LB Update 273 (Sascha 30.09.): Benachrichtigen-Fenster am Handy - unter dem Blatt war die Safari-Leiste
   unten grauer als das Blatt. Safari faerbt diese Leiste nach dem FESTEN Element am unteren Bildschirmrand
   (beim Newsletter ist das Blatt fest angeheftet -> gleiche Farbe). Hier wird das Blatt am Handy ebenfalls fest
   unten angeheftet (position:fixed, links/rechts/unten 0) - Lage, Groesse und Bewegung bleiben gleich.
   lb-bis.js bleibt unveraendert; die Regel kommt nach jedem Oeffnen in den Schattenbereich (lb-bis entfernt
   beim Oeffnen alte Stilbloecke). */
(function(){
  /* LB Update 274 (Sascha 30.09.): Am Handy erscheint das Fenster jetzt als Karte genau in der Mitte -
     links/rechts 16 px Abstand (wie "Bevor du dich verabschiedest"), oben und unten gleich viel Platz,
     alle vier Ecken 26 px rund, die Seite ist oben und unten (abgedunkelt) zu sehen. Inhalt und Groessen
     bleiben; statt Hochgleiten von unten kommt die Karte weich eingeblendet (wie am Computer).
     Damit ersetzt 274 die Regel aus 273 (Blatt fest unten). */
  var CSS='@media (max-width:768px){'+
    '.o{align-items:center;padding:16px}'+
    '.o>.s{position:relative;width:100%;max-width:460px;margin:0;border-radius:26px;padding-bottom:30px;box-shadow:0 20px 60px rgba(36,33,30,.22);'+
      'transform:translateY(16px) scale(.98);opacity:0;transition:transform .24s cubic-bezier(.22,.61,.36,1),opacity .2s ease-out}'+
    '.o.on>.s{transform:none;opacity:1}'+
    /* LB 286 (Sascha: Benachrichtigen schliesst zu langsam, Newsletter/Verabschiedest sofort): Beim Schliessen blenden Karte (.16 s) und
       Schleier (.2 s) noch aus - jetzt sofort weg wie beim Newsletter. Oeffnen bleibt unveraendert (dort gilt die Zeit des Ziel-Zustands .on). */
    '.o:not(.on)>.s{transform:translateY(8px) scale(.98);opacity:0;transition:none}'+
    '.o:not(.on)::before{opacity:0;transition:none}'+
    /* LB 287: Video 21:56 - nach dem Schliessen stand der (leere) Behaelter .o noch ca. 0,4 s im Schattenbereich; Safari las ihn und hielt die
       Leiste unten 0,4 s grau (Newsletter: 0,1 s). Jetzt ist er beim Schliessen sofort unsichtbar (Safari uebergeht visibility:hidden). */
    '.o:not(.on){visibility:hidden}'+
    '.o.an .s::after,.o .s::after{content:none;display:none}'+
    /* "10 % Gutschein" nicht zwischen 10 und % umbrechen (Karte ist schmaler als das alte Blatt) */
    '.n strong{white-space:nowrap}'+
    /* Tastatur offen: theme.liquid (LB 213-222) schiebt den Inhalt mit Abstand unten ueber die Tastatur - dafuer
       sitzt die Karte dann wie bisher unten an (sonst ragt sie auf kleinen Handys ueber den Rand). */
    '.o:has(>.s[style*="padding-bottom"]){align-items:flex-end;padding-bottom:0}'+
  '}'+
  '@media (max-width:768px) and (prefers-reduced-motion:reduce){.o>.s,.o.on>.s,.o:not(.on)>.s{transition:none!important}}';
  function einfuegen(){
    var h=document.getElementById('lb-bis-host'),r=h&&h.shadowRoot;
    if(!r||r.querySelector('style[data-lb273]'))return;
    var st=document.createElement('style');st.setAttribute('data-lb273','');st.textContent=CSS;r.appendChild(st);
  }
  if(typeof MutationObserver!=='function')return;
  new MutationObserver(function(){
    if(document.documentElement.classList.contains('lb-bis-open'))einfuegen();
  }).observe(document.documentElement,{attributes:true,attributeFilter:['class']});
})();

/* LB Update 275 (Sascha 30.09.): Das Newsletter-Fenster erscheint am Handy jetzt genauso wie das
   Benachrichtigen-Fenster (274): Karte genau in der Mitte, 16 px links/rechts, oben und unten gleich viel
   Platz, alle Ecken 26 px rund, weiches Einblenden (wie am Computer) statt Hochgleiten.
   Mit offener Tastatur (theme.liquid setzt dann unten Abstand) sitzt die Karte wie bisher unten an.
   Inhalt, Texte, Haekchen und Hoehen bleiben unveraendert. */
(function(){
  if(document.getElementById('lb-nl-mitte'))return;
  var P='html body [id^="NewsletterPopup-"].modal.modal--mobile-friendly';
  var css='@media (max-width:768px){'+
    P+' .modal__inner{top:50%!important;bottom:auto!important;left:16px!important;right:16px!important;width:auto!important;max-width:460px!important;margin:0 auto!important;'+
      'border-radius:26px!important;padding-bottom:0!important;transform:translateY(-50%)!important;box-shadow:0 20px 60px rgba(36,33,30,.22)!important}'+
    P+'.lb-nl-an .modal__inner{box-shadow:0 20px 60px rgba(36,33,30,.22)!important}'+
    P+' .modal__centered-content{padding-bottom:30px!important}'+
    'html.modal-open body [id^="NewsletterPopup-"].modal.modal--mobile-friendly .modal__inner{animation:lb-nl-auf-d .24s cubic-bezier(.22,.61,.36,1) backwards}'+
    'html.modal-closing body [id^="NewsletterPopup-"].modal.modal--mobile-friendly .modal__inner{animation:lb-nl-zu-d .18s ease-in forwards}'+
    /* Tastatur offen: wie bisher unten ansetzen (Abstand kommt aus theme.liquid, LB 213-222) */
    P+' .modal__inner:has(.modal__centered-content[style*="padding-bottom"]){top:auto!important;bottom:0!important;transform:none!important}'+
  '}'+
  '@media (max-width:768px) and (prefers-reduced-motion:reduce){html.modal-open body [id^="NewsletterPopup-"].modal.modal--mobile-friendly .modal__inner{animation:none}}';
  try{var st=document.createElement('style');st.id='lb-nl-mitte';st.textContent=css;(document.head||document.documentElement).appendChild(st);}catch(e){}
})();

/* LB Update 275, Teil 2 (Sascha 30.09.): Farbe der Safari-Leisten am iPhone, solange Newsletter- oder
   Benachrichtigen-Fenster offen ist.
   Safari 26 faerbt Statusleiste (oben) und Leiste unten nach FESTEN Elementen am Rand (nur echte Elemente,
   keine ::before-Schleier, ab 90 % Breite und > 10 px Hoehe, sichtbar ueber Deckkraft 0,1). Findet es nichts
   Neues, bleibt oft die alte Farbe stehen (darum unten Blattfarbe / oben Weiss).
   - oben: 12-px-Streifen in Kopfzeilenfarbe #E5D9CB unter dem Schleier -> Statusleiste bleibt wie auf der Seite.
   - unten: 12-px-Streifen in Schleierfarbe (fast unsichtbar, Deckkraft .15) -> Leiste unten abgedunkelt
     durchsichtig wie die Seite, keine eigene Farbe.
   Beide nur am Handy und nur solange ein Fenster offen ist (sonst display:none, damit Safari sie nicht liest). */
(function(){
  if(document.getElementById('lb-rand-stil'))return;
  var css='#lb-rand-oben,#lb-rand-unten{display:none}'+
    '@media (max-width:768px){'+
      /* LB 280: Beim Schliessen des Newsletters wurde die Leiste unten ca. 0,5 s braun (Video 20:59): ohne Streifen las Safari
         den noch ausblendenden Schleier. Jetzt bleibt unten kurz (LB 282: nur 0,25 s, sonst blieb der weisse Balken zu lange) ein WEISSER Streifen (Seitenfarbe, multiply = unsichtbar),
         die Leiste wird sofort wieder weiss wie beim Benachrichtigen-Fenster. */
      /* LB 284 (Sascha: Newsletter schliesst zu spaet/langsam, "Bevor du dich verabschiedest" schliesst perfekt, weil es sofort weg ist):
         Das Newsletter-Fenster blieb nach dem Schliessen noch ca. 0,5 s sichtbar (Ausblend-Animation) - in dieser Zeit las Safari die Leiste
         falsch (beige, Farbwechsel). Jetzt ist es beim Schliessen sofort weg, wie das Verabschiedest-Fenster. */
      'html.modal-closing [id^="NewsletterPopup-"].modal{display:none!important}'+
      'html.lb-rand-halten #lb-rand-oben{display:block}'+
      'html.lb-rand-halten-u #lb-rand-unten{display:block;background-color:#fff;mix-blend-mode:multiply}'+
      'html.lb-bis-open #lb-rand-oben,html.lb-bis-open #lb-rand-unten,'+
      'html.modal-open:has([id^="NewsletterPopup-"].modal--is-active) #lb-rand-oben,html.modal-open:has([id^="NewsletterPopup-"].modal--is-active) #lb-rand-unten{display:block}'+
      /* LB 276: Safari prueft einen Punkt 4-8 px innerhalb des Rands und nimmt das OBERSTE Element dort -
         darum liegen die Streifen jetzt ueber allem (vorher darunter -> Safari sah den Schleier und fror
         eine alte Farbe ein). Deckkraft .12: fast unsichtbar, Safari liest trotzdem die Farbe. */
      /* LB 277 (Sascha): oben soll die Leiste so abgedunkelt sein wie die Seite darunter (weisse Kopfzeile
         unter dem Schleier = rgb(134,132,131), am iPhone gemessen) - der Streifen hat genau diese Farbe, darum kein heller Strich mehr.
         Unten soll KEINE Farbe kommen, sondern die abgedunkelte Seite durchscheinen: WebKit uebergeht feste
         Behaelter mit visibility:hidden. Der untere Streifen ist deshalb unsichtbar (visibility:hidden) und hat
         nur ein sichtbares, farbloses Kind, auf das Safari trifft -> kein fester Behaelter mit Farbe -> Glas. */
      '#lb-rand-oben,#lb-rand-unten{position:fixed;left:0;right:0;height:12px;z-index:2147483001}'+
      /* LB 278 (Sascha): oben soll die Leiste NICHT abdunkeln, sondern so bleiben wie vorher (Beige der Kopfzeile #e5d9cb).
         Unten kam mit dem visibility-Trick (277) trotzdem Farbe - jetzt bekommt der untere Streifen die Farbe der
         abgedunkelten Seite (rgb(134,132,131)), damit die Leiste unten wie die abgedunkelte Seite aussieht. */
      /* LB 279: mix-blend-mode:multiply - der 12-px-Streifen oben war als heller Strich unter der Statusleiste sichtbar
         (Video 20:34: 154 statt 144). Mit multiply verdunkelt er nur ca. 1 % = unsichtbar, Safari liest trotzdem die Farbe. */
      '#lb-rand-oben{top:0;background-color:#e5d9cb;opacity:.12;mix-blend-mode:multiply}'+
      '#lb-rand-unten{mix-blend-mode:normal}'+
      '#lb-rand-unten{bottom:0;background-color:rgb(134,132,131);opacity:.12}'+
    '}';
  function los(){
    if(!document.body||document.getElementById('lb-rand-oben'))return;
    var st=document.createElement('style');st.id='lb-rand-stil';st.textContent=css;(document.head||document.documentElement).appendChild(st);
    ['lb-rand-oben','lb-rand-unten'].forEach(function(id){var d=document.createElement('div');d.id=id;d.setAttribute('aria-hidden','true');document.body.appendChild(d);});
  }
  if(document.body)los();else document.addEventListener('DOMContentLoaded',los);
  /* LB 279: Beim SCHLIESSEN des Fensters wurde die Statusleiste kurz grau (Video 20:34: 151/144 statt Beige),
     weil der obere Streifen sofort wegfiel. Er bleibt jetzt noch 1 s stehen, bis die Seite wieder hell ist. */
  try{
    var de=document.documentElement,war=false,tm=0,tu=0;
    var offen=function(){return de.classList.contains('lb-bis-open')||(de.classList.contains('modal-open')&&!!document.querySelector('[id^="NewsletterPopup-"].modal--is-active'));};
    new MutationObserver(function(){
      var jetzt=offen();
      if(war&&!jetzt&&!de.classList.contains('lb-rand-halten')){de.classList.add('lb-rand-halten');/* LB 285: kein Halten unten mehr - wie bei Verabschiedest */clearTimeout(tu);var t0=Date.now();
        /* LB 283: Der Newsletter-Behaelter bleibt nach dem Schliessen noch ca. 0,5 s sichtbar (display:flex). Wird der weisse Streifen
           vorher entfernt, liest Safari ihn und die Leiste unten wird kurz beige (Video 21:17). Darum: Streifen bleiben, bis er weg ist (mind. 0,15 s, hoechstens 0,8 s). */
        (function warte(){var el=document.querySelector('[id^="NewsletterPopup-"]');var da=el&&getComputedStyle(el).display!=='none';var d=Date.now()-t0;
          if(d<150||(da&&d<800)){tu=setTimeout(warte,40);return;}
          if(de.classList.contains('lb-rand-halten-u'))de.classList.remove('lb-rand-halten-u');})();clearTimeout(tm);tm=setTimeout(function(){if(de.classList.contains('lb-rand-halten'))de.classList.remove('lb-rand-halten');},1000);}
      if(jetzt&&(de.classList.contains('lb-rand-halten')||de.classList.contains('lb-rand-halten-u'))){clearTimeout(tm);clearTimeout(tu);de.classList.remove('lb-rand-halten','lb-rand-halten-u');}
      war=jetzt;
    }).observe(de,{attributes:true,attributeFilter:['class']});
  }catch(e){}
})();

/* LB Update 288 (Sascha 01.10., Safari am Mac):
   a) Warenkorb: Wird das letzte Produkt entfernt, stand die rote Box "Hohe Nachfrage" noch ca. 0,9 s im leeren Warenkorb und
      verschwand dann - dadurch sprang alles darunter ca. 64 px nach oben (Video 16:26). Im leeren Warenkorb ist die Box ohnehin
      weg; jetzt ist sie sofort weg, also kein Sprung mehr. Der volle Warenkorb und die geschuetzten Warenkorb-Dateien bleiben unveraendert.
   b) Sprachfenster am Computer: alle sieben Sprachen mit Fahne in EINER Reihe, Fenster dafuer breiter (Handy unveraendert). */
(function(){
  if(document.getElementById('lb-288-stil'))return;
  var css='#CartDrawer .drawer__cart-empty .lb-demand{display:none!important}'+
    /* LB 288b (Sascha 02.10., Handy): Das aktive Land (Deutsch) bekam beim Oeffnen den Fokus und hob sich 2 px an - dadurch stand sein Abstand oben anders als bei den anderen Fahnen.
       Am Handy kein Anheben mehr; Abstand zwischen den Reihen = Abstand Text -> erste Reihe (26 px). */
    '@media (max-width:768px){'+
      'html body .lb-sprache .lb-sprache__wahl:hover .lb-flag,html body .lb-sprache .lb-sprache__wahl:focus .lb-flag,html body .lb-sprache .lb-sprache__wahl:focus-visible .lb-flag{transform:none}'+
      'html body .lb-sprache .lb-sprache__liste{row-gap:26px;column-gap:0;gap:26px 0}'+
      /* LB 288c (Sascha 02.10.): Abstand von Fahne zu Fahne war ungleich (Spalten so breit wie ihr Text). Jetzt vier gleich breite Spalten (4 + 3 mittig),
         damit die Fahnen in jeder Reihe gleich weit auseinander stehen. */
      'html body .lb-sprache .lb-sprache__box{padding-left:12px;padding-right:12px}'+
      'html body .lb-sprache .lb-sprache__liste li{width:25%;display:flex;justify-content:center}'+
      'html body .lb-sprache .lb-sprache__wahl{font-size:14px;width:100%}'+
    '}'+
    '@media (max-width:380px){html body .lb-sprache .lb-sprache__box{padding-left:6px;padding-right:6px}html body .lb-sprache .lb-sprache__wahl{font-size:13px}}'+
    '@media (min-width:900px){'+
      'html body .lb-sprache .lb-sprache__box{max-width:920px;padding-left:40px;padding-right:40px}'+
      'html body .lb-sprache .lb-sprache__liste{flex-wrap:nowrap;gap:24px 36px}'+
    '}';
  try{var st=document.createElement('style');st.id='lb-288-stil';st.textContent=css;(document.head||document.documentElement).appendChild(st);}catch(e){}
})();



